import { render } from "./Exchange.vue?vue&type=template&id=3509c90f&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=ts"
export * from "./Exchange.vue?vue&type=script&lang=ts"

import "./Exchange.vue?vue&type=style&index=0&id=3509c90f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3509c90f"

export default script